const $ = window.$;

export const VIEWS = {
  root: '/',
  chooseLessor: '/chooseLessor',
  home: '/home',
  search: '/search',
  objectDetails: '/objectDetails',
  bwOfferDetails: '/bookingWizard/1',
  bwServices: '/bookingWizard/2',
  bwAccessories: '/bookingWizard/3',
  bwPersonalData: '/bookingWizard/4',
  bwReview: '/bookingWizard/5',
  bwPayment: '/bookingWizard/6',
  bwBookingSuccessful: '/bookingWizard/7',
  bwFinished: '/bookingFinished',
  userProfile: '/userProfile',
  changePassword: '/changePassword',
  recentBookings: '/recentBookings',
  recentBookingDetail: '/recentBookingDetail/:trxId',
  userRegistration: '/userRegistration/:step',
  forgottenPassword: '/forgottenPassword/:step',

  confirmRegistration: '/confirmRegistration', 
  confirmPasswordReset: '/confirmPasswordReset',

  confirmPayment: '/confirmPayment',
  cancelPayment: '/cancelPayment',
  errorPayment: '/errorPayment',
};

export const ADDRESS_TYPE_ORDER = [
    'POST', 'RECHNUNG', 'LIEFER',
];

export const ADDRESS_TYPE = {
  RECHNUNG: "eb690d73-42ad-42d8-a193-90f4d64f2f02",
  LIEFER: "d4e9ca4f-4c14-4771-a5a4-e0adf28861e1",
  POST: "a9108a5f-8c9e-4bc2-8a7b-ee12fba7500c",
};

export const PAYMENT_TYPE = {
  BANKUBERWEISUNG: "72fb5af6-8bdb-47a2-aa19-6d649de40e3e",
  UBERNAHME: "3a7b3288-8de7-408c-86d1-ac65ff33bafd",
  KREDITKARTENZAHLUNG: "54bcac28-7d99-4e71-8a9e-bac2bbe7e550",
  PERIODISCHERECHNUNG: "0df9dcb9-ae21-49e8-b7a2-81d6098ad735"
};

export const SERVICE_TYPE = {
  BEIRESERVATION: "99d04f60-dff1-4412-b447-214e948aab9b",
  WAHLBAR: "a8431036-b0e8-4a5e-8cc5-5031ddb781cd",
  BEDINGT: "92afec83-4ba6-491d-aa65-15c0a858b083",
  OBLIGATORISCH: "7c111e78-b162-4466-977f-9b49fea69127",
};
  
export const ATTACHMENT_TYPE = {
  PICTURE: "8d53bc5a-6d95-4e97-aa25-40c169a3f670",
  DOCUMENT: "64a2202d-0d83-42f4-b945-700bd9b99cce",
}

export const PARAMETER_TYPE = {
  
};
 
export const BOOKING_STATUS_TYPE = {
  BOOKED: 'a198f429-6e7d-4a46-b94f-08164c47e1a0',
  CANCELLED: 'cb067253-4185-4749-90c0-139e20ffac5c'
};



export const TIME_UNIT_ID = {
  DAY2:          'd1cc8f38-3c0c-4112-8072-2de5e58c54a9',
  DAY:          'c235f59e-d232-4442-a264-5a5e13f54591',
  HALFDAY:      '11bc8c97-4bd2-4f36-8aa7-9cab54043de3',
  NIGHT:        '524d9afa-c125-440f-b2cb-fd881280ef63',
  HOUR:         'c90fb58d-c51d-4aae-a049-8cb08c25949e',
  WEEK:         '70ac7c1f-44ad-4697-8ac5-c808ae930cab',
  MONTH:        '117bad75-3651-4e83-9dc3-d7cb8bcfb2bc',
  QUARTER_HOUR: '780ad4c2-b74f-4fde-81e6-5d7710148915',
};

export const TIME_UNIT_DURATION = {
  [TIME_UNIT_ID.DAY]: 24*60*60,
  [TIME_UNIT_ID.DAY2]: 24*60*60,
  [TIME_UNIT_ID.HALFDAY]: 12*60*60,
  [TIME_UNIT_ID.NIGHT]: 24*60*60,
  [TIME_UNIT_ID.HOUR]: 60*60,
  [TIME_UNIT_ID.WEEK]: 7*24*60*60,
  [TIME_UNIT_ID.MONTH]: 30*24*60*60,  
  [TIME_UNIT_ID.QUARTER_HOUR]: 15*60, 
}

export const BOOKINGS_FILTER_TYPE = {
  ARCHIVED: 'ARCHOVED',
  ACTIVE: 'ACTIVE',
}

export const UI_LANGUAGE = {
  'en-US': 'English',
  'de-CH': 'Deutsch',
  'fr-CH': 'Français',
  'cs-CZ': 'Čeština'
};



const SWIPER_BASIC_PROPS = {
    direction: 'horizontal',
    mousewheelControl: true,
    mousewheelForceToAxis: true,
    mousewheelSensitivity: 1,
    slidesPerView: 'auto',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'            
};

export const FILTER_SWIPER_PROPS = $.extend({
    grabCursor: false,
    spaceBetween: 0,
},  SWIPER_BASIC_PROPS);

export const IMAGE_SWIPER_PROPS = $.extend({
    grabCursor: true,
    spaceBetween: 2
},  SWIPER_BASIC_PROPS);

export const THUMB_SWIPER_PROPS = $.extend({
    spaceBetween: 0,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    centeredSlides: true
},  SWIPER_BASIC_PROPS, { direction: 'vertical', mousewheelControl: false });


// WEBPACK FOOTER //
// ./src/model/const.js